var _excluded = ["children"];

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import Button from "../Button/Button";

var Toggle = function Toggle(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({
    color: "link",
    size: "sm",
    className: "p-0 m-0 ms-2"
  }, props), children);
};

Toggle.displayName = "Toggle";

var CollapsableText = function CollapsableText(_ref2) {
  var _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? '' : _ref2$children,
      _ref2$collapsed = _ref2.collapsed,
      defaultCollapsed = _ref2$collapsed === void 0 ? true : _ref2$collapsed,
      _ref2$lessLabel = _ref2.lessLabel,
      lessLabel = _ref2$lessLabel === void 0 ? 'Show Less' : _ref2$lessLabel,
      _ref2$maxLength = _ref2.maxLength,
      maxLength = _ref2$maxLength === void 0 ? 256 : _ref2$maxLength,
      _ref2$moreLabel = _ref2.moreLabel,
      moreLabel = _ref2$moreLabel === void 0 ? 'Show More' : _ref2$moreLabel;

  var _useState = useState(defaultCollapsed),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var toggle = function toggle() {
    return setCollapsed(!collapsed);
  };

  useEffect(function () {
    return setCollapsed(defaultCollapsed);
  }, [defaultCollapsed]);

  if (children.length < maxLength) {
    return children;
  }

  if (collapsed) {
    return /*#__PURE__*/React.createElement("span", null, children.substring(0, maxLength).trim(), "\u2026", ' ', /*#__PURE__*/React.createElement(Toggle, {
      onClick: function onClick() {
        return toggle();
      }
    }, moreLabel));
  }

  return /*#__PURE__*/React.createElement("span", null, children, " ", /*#__PURE__*/React.createElement(Toggle, {
    onClick: function onClick() {
      return toggle();
    }
  }, lessLabel));
};

CollapsableText.displayName = "CollapsableText";
CollapsableText.defaultProps = {
  children: '',
  collapsed: true,
  lessLabel: 'Show Less',
  maxLength: 256,
  moreLabel: 'Show More'
};
CollapsableText.displayName = 'CollapsableText';
export default CollapsableText;